import React from 'react';
import SearchUsersContent from './SearchUsersContent';

const SearchUsers: React.FC = () => {
  return <SearchUsersContent />;
};

export default SearchUsers;
